import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import PostRegistrationController from 'cio/pods/authenticated/post-registration/controller';
import { redirectIfNoPermission } from 'cio/utils/route-access';
import Transition from '@ember/routing/-private/transition';
import AccountService from 'cio/services/account';

export default class PostRegistrationRoute extends Route {
  @service account!: AccountService;

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    // access restriction is simplified to only respond to user role, not account state
    // this is done to avoid extending BaseAuthorizedRoute class, which brings more complexity and is not needed
    // it also allows handling some edge cases semi-gracefully, e.g. when customer registers for a trial but doesn't confirm account until it expires:
    // in which case access to post-registration form should be allowed, even if dashboard of the app is not available
    return redirectIfNoPermission(this, 'account/edit', transition);
  }

  model() {
    return this.account.current;
  }

  activate() {
    let controller = this.controllerFor(this.routeName) as PostRegistrationController;
    controller.waitForAccountToBeReadyTask.perform();
  }

  deactivate() {
    let controller = this.controllerFor(this.routeName) as PostRegistrationController;
    controller.waitForAccountToBeReadyTask.cancelAll();
  }
}
